export default __webpack_public_path__ + "static/media/fv_reports.86b4b4a4.svg";